export default __webpack_public_path__ + "static/media/register.4ea0f6c2.png";